import React from 'react'
import { Pagination } from '@mui/material'
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid'
import PropTypes from 'prop-types'

/** @type {import('@mui/x-data-grid').GridColDef} */
export const DEF_COL_DEFS = {
  flex: 1,
  disableReorder: true
}

/**
 * @typedef {Object} DataGridWrapperProps
 * @prop {string} [tableHeight]
 *
 * // added for readability - these fields will overlap in the type intersection
 * @prop {import('@mui/x-data-grid').GridColDef[]} columns
 * @prop {import('@mui/x-data-grid').GridRowsProp} rows
 */

/** @type {import('react').CSSProperties & Object.<string, import('react').CSSProperties>} */
const gridStyles = {
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bolder',
    fontSize: '12px'
  },
  '.MuiDataGrid-cellContent': {
    fontSize: '12px'
  },
  border: 'none'
}

function CustomPagination() {
  const apiRef = useGridApiContext()
  const page = useGridSelector(apiRef, gridPageSelector)
  const pageCount = useGridSelector(apiRef, gridPageCountSelector)

  return (
    <Pagination
      color='primary'
      count={pageCount}
      page={page + 1}
      onChange={(_event, value) => apiRef.current.setPage(value - 1)}
    />
  )
}

/**
 * @param {import('@mui/x-data-grid').DataGridProps & DataGridWrapperProps} props
 */
function MUIDataGrid(props) {
  const { tableHeight = '500px', ...dataGridProps } = props
  const { sx, initialState, components, ...miscDgProps } = dataGridProps

  const mappedColumns = dataGridProps.columns.map((c) => ({
    ...DEF_COL_DEFS,
    ...c
  }))

  return (
    <div style={{ height: tableHeight, width: '100%' }}>
      <div style={{ display: 'flex', height: '100%' }}>
        <div style={{ flexGrow: 1 }}>
          <DataGrid
            sx={{ ...gridStyles, ...sx }}
            disableColumnMenu
            initialState={{
              pagination: {
                pageSize: 10
              },
              ...initialState
            }}
            components={{
              Pagination: CustomPagination,
              ...components
            }}
            {...miscDgProps}
            columns={mappedColumns}
          />
        </div>
      </div>
    </div>
  )
}

MUIDataGrid.propTypes = {
  tableHeight: PropTypes.string
}

export default MUIDataGrid
